import React from 'react';
import { formatCents } from './affiliateForm';

export default function AffiliateEarningsPanel({ summary }) {
  const commission = summary?.lifetime?.commission || {};
  return (
    <section className="affiliate-earnings-panel" aria-label="Affiliate earnings">
      <h2>Earnings</h2>
      <div className="affiliate-stat-grid">
        <div><span>Pending</span><strong>{formatCents(commission.pending)}</strong></div>
        <div><span>Payable</span><strong>{formatCents(commission.payable)}</strong></div>
        <div><span>Paid</span><strong>{formatCents(commission.paid)}</strong></div>
        <div>
          <span>Current balance</span>
          <strong>{formatCents(summary?.currentBalance)}</strong>
        </div>
      </div>
      <p className="help">
        Pending earnings mature after the code’s holdback window. Payable earnings are included in
        an eligible payout; reversals can reduce the current balance.
      </p>
    </section>
  );
}
